import { render, staticRenderFns } from "./flatpay.vue?vue&type=template&id=2c8ecd6e&"
import script from "./flatpay.vue?vue&type=script&lang=js&"
export * from "./flatpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports